<template>
  <div class="emd-interactive-list eu-pb_3">
    <div
      class="emd-interactive-list__search"
      v-if="showSearch"
    >
      <div class="emd-input-group">
        <input
          class="emd-input"
          type="text"
          :placeholder="$t('account.production.search')"
          v-model="identifier"
          v-on:input="searchProdAccount(identifier)"
        />
        <i class="uil uil-search"></i>
      </div>
    </div>
    <div class="emd-interactive-list__main">
      <p
        class="emd-text"
        v-if="!loadingList && !prodAccounts.items.length"
      >
        {{ $t('account.production.no-results') }}
      </p>
      <div
        class="emd-loader _invert eu-align_center eu-pa_3"
        v-if="loadingList"
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
      <ul v-else>
        <li
          class="emd-select-list__item"
          v-for="(acc, index) in prodAccounts.items"
          :key="index"
          v-bind:class="{ _active: acc.id === account.id }"
          v-on:click="goToAccount(acc.id)"
        >
          <span class="emd-interactive-list__label">
            <span
              class="emd-status-tag"
              :class="
                acc.status == 'inactive' ? '_color_danger' : '_color_success'
              "
              :title="$t(`account.production.${acc.status}`)"
            >
              <emerald-icon
                icon="circle"
                size="xs"
                fixed-width
              />
            </span>
            {{ acc.name }}
          </span>
          <span
            class="emd-interactive-list__select-icon"
            v-if="acc.id === account.id"
          >
            <i
              class="uil uil-check-circle"
              transform="width-16"
            />
          </span>
        </li>
      </ul>
    </div>
    <div
      class="emd-interactive-list__pagination"
      v-if="!loadingList && prodAccounts.pagination.total_page > 1"
    >
      <button
        class="emd-btn _type_text _size_small"
        v-bind:class="{ _disabled: prodAccounts.pagination.current_page === 1 }"
        v-on:click.stop="goToPage(page - 1)"
        :disabled="prodAccounts.pagination.current_page === 1"
      >
        {{ $t('account.production.previous') }}
      </button>
      <span class="emd-text _size_tiny _align_center">
        {{ prodAccounts.pagination.current_page }}
        {{ $t('account.production.of') }}
        {{ prodAccounts.pagination.total_page }}
      </span>
      <button
        class="emd-btn _type_text _size_small"
        v-bind:class="{
          _disabled:
            prodAccounts.pagination.current_page ===
            prodAccounts.pagination.total_page
        }"
        v-on:click.stop="goToPage(page + 1)"
        :disabled="
          prodAccounts.pagination.current_page ===
          prodAccounts.pagination.total_page
        "
      >
        {{ $t('account.production.next') }}
      </button>
    </div>
  </div>
</template>

<script>
import { EmeraldIcon } from 'emerald-vue/src/components'

export default {
  name: 'InteractiveListProduction',
  components: {
    EmeraldIcon
  },
  props: {
    merchant: {
      type: Object
    },
    account: {
      type: Object
    }
  },
  data () {
    return {
      identifier: '',
      page: 1,
      debounceTimer: undefined
    }
  },
  computed: {
    prodAccounts () {
      return this.$store.getters.prodAccounts
    },
    loadingList () {
      return this.$store.getters.loadingListProdAccount
    },
    showSearch () {
      if (
        !Object.entries(this.prodAccounts.items).length &&
        !this.identifier &&
        this.loadingList
      ) {
        return false
      }
      return this.prodAccounts.pagination.total_items > 5 || this.identifier
    }
  },
  methods: {
    getProdAccounts (merchantId, query = {}) {
      this.$store.dispatch('UPDATE_LOADING_LIST_PROD_ACCOUNT', true)
      query.size = 5
      this.$store
        .dispatch('GET_PROD_ACCOUNTS', { merchantId, query })
        .then(res => {
          this.$store.dispatch('UPDATE_LOADING_LIST_PROD_ACCOUNT', false)
        })
    },
    searchProdAccount (identifier) {
      this.$store.dispatch('UPDATE_LOADING_LIST_PROD_ACCOUNT', true)
      this.page = 1
      const query = { identifier: identifier }
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.getProdAccounts(this.merchant.id, query)
      }, 750)
    },
    goToPage (page) {
      this.$store.dispatch('UPDATE_LOADING_LIST_PROD_ACCOUNT', true)
      this.page = page
      const query = { page: this.page }
      if (this.identifier) {
        query.identifier = this.identifier
      }
      this.getProdAccounts(this.merchant.id, query)
    },
    async goToAccount (accountId) {
      this.$store.dispatch('toggleGlobalLoading', true)
      this.$store.dispatch('RESET_ACCOUNT_ENABLED')
      await this.$router.push({ path: `/${this.merchant.id}/${accountId}` })
      this.$nextTick().then(() => {
        window.location.reload()
      })
    }
  },
  activated () {
    this.getProdAccounts(this.merchant.id)
  }
}
</script>
